import styled from 'styled-components';
import { Flex } from '@finect/tabular-core/Flex';
import { getFont } from '@finect/tabular-utils/getFont';
export var ProductTitle = styled.h3.withConfig({
  displayName: "partials__ProductTitle",
  componentId: "sc-dmzpxp-0"
})(["margin-bottom:16px;", " font-weight:700;color:", ";"], getFont(0, 'compact'), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.terciaryD;
});
export var IconBlock = styled.div.withConfig({
  displayName: "partials__IconBlock",
  componentId: "sc-dmzpxp-1"
})(["flex-shrink:0;margin-right:12px;"]);
export var Inner = styled(Flex).withConfig({
  displayName: "partials__Inner",
  componentId: "sc-dmzpxp-2"
})(["&:not(:last-child){margin-bottom:36px;}"]);
export var OrganizationLabel = styled.div.withConfig({
  displayName: "partials__OrganizationLabel",
  componentId: "sc-dmzpxp-3"
})(["", " font-variant:small-caps;line-height:1;color:", ";text-transform:lowercase;"], getFont(-2), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.fontL;
});